<template>
  <v-container fluid :class="{'px-0':esMovil}">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row align="center" justify="center" :class="{'pa-2':!esMovil, 'ma-4':!esMovil,'mt-0':esMovil}"
               :no-gutters="esMovil">
          <v-card :width="esMovil ? '100%' : '500px'" :elevation="esMovil ? 0 : undefined">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ $t('registro') }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <perfil-editar-component v-model="modeloPerfilValido" :perfil.sync="modeloPerfil"/>
              <v-text-field :label="$t('label_contrasenya')" v-model="contrasenya" type="password"
                            :rules="[requerido, counter6]" prepend-inner-icon="mdi-lock"/>
              <v-text-field :label="$t('label_contrasenya_confirmacion')"
                            v-model="contrasenya_confirmacion"
                            :rules="[requerido, contrasenyaConfirmacion]"
                            type="password" prepend-inner-icon="mdi-lock"/>
              <politica-privacidad-component v-model="politica_aceptada"/>
            </v-card-text>
            <v-card-actions>
              <v-row no-gutters class="mt-0">
                <v-col cols="12" class="text-right pr-3">
                  <v-btn color="primary"
                         :disabled="!registroValido()"
                         :loading="registrando"
                         @click="registro()">
                    <span class="mr-2">{{ $t('registrate') }}</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import PerfilEditarComponent from "@/components/PerfilEditarComponent";
import PoliticaPrivacidadComponent from "@/components/PoliticaPrivacidadComponent";

export default {
  name: 'RegistroPagina',
  components: {PerfilEditarComponent, PoliticaPrivacidadComponent},
  data: () => ({
    modeloPerfilValido: false,
    modeloPerfil: {
      usuario: "",
      nombre: "",
      empresa: "",
      cargo: "",
      tipo: ""
    },
    contrasenya: "",
    contrasenya_confirmacion: "",
    politica_aceptada: false,
    registrando: false
  }),
  computed: {
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    requerido(value) {
      return !!value || this.$tc('requerido', 1)
    },
    counter6(value) {
      return value.length >= 6 || this.$t('minimo6')
    },
    contrasenyaConfirmacion(confirmacion) {
      return this.contrasenya === confirmacion || this.$t('contr_coin');
    },
    registroValido() {
      if (!this.modeloPerfilValido) return false;
      if (this.contrasenya.length <= 0) return false;
      if (this.contrasenya_confirmacion.length <= 0) return false;
      if (this.politica_aceptada !== true) return false;

      if (this.contrasenya !== this.contrasenya_confirmacion) return false;

      return true;
    },
    registro() {
      this.registrando = true;

      let params = {
        tipo: this.modeloPerfil.tipo,
        nombre_usuario: this.modeloPerfil.usuario,
        nombre: this.modeloPerfil.nombre,
        empresa: this.modeloPerfil.empresa,
        cargo: this.modeloPerfil.cargo,
        contrasenya: this.contrasenya,
        contrasenya_confirmacion: this.contrasenya_confirmacion,
        politica_aceptada: this.politica_aceptada
      };

      HttpHelper.post("auth/registro", params)
          .then(() => {
            this.$gtag.event('registro-competado', {
              'event_category': 'registro-competado',
              'event_label': 'registro-competado',
              'value': this.usuario
            });
            this.modeloPerfil.usuario = "";
            this.modeloPerfil.nombre = "";
            this.modeloPerfil.empresa = "";
            this.modeloPerfil.cargo = "";
            this.contrasenya = "";
            this.contrasenya_confirmacion = "";
            this.politica_aceptada = false;
            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: this.$t("registro_completado_msg"),
              color: "success"
            });
            VueRouteHelper.goTo("/login", this.$router);
          })
          .catch((error) => {
            let msg = error && Object.prototype.hasOwnProperty.call(error, 'mensaje')
                ? error.mensaje : this.$t('error_registro');

            this.$store.commit(MOSTRAR_SNACKBAR, {
              texto: msg,
              color: "error"
            });
          })
          .finally(() => {
            this.registrando = false;
          })
    }
  }
};
</script>

<!-- @formatter:off -->
<i18n>
{
  "es": {
    "registro": "Regístrese rellenando el formulario",
    "registrate": "Regístrate",
    "label_contrasenya": "Contraseña",
    "label_contrasenya_confirmacion": "Repite la contraseña",
    "requerido": "Requerido",
    "minimo6": "Mínimo 6 carácteres",
    "contr_coin": "Las contraseñas deben coincidir",
    "error_registro": "Ha ocurrido un error desconocido en el registro.",
    "registro_completado": "Registro completado",
    "registro_completado_msg": "El registro se ha realizado de forma correcta, en breve recibirás un correo electrónico para poder activar tu cuenta."
  }
}
</i18n>
<!-- @formatter:on -->